<script setup lang="ts">
import { RouterView } from 'vue-router'
import Box from '@uiKit/elements/Box.vue'
import AuthFooter from './AuthFooter.vue'

// Pre-auth shell (login, verify-otp, landing). The auth module will add its
// own top header inside this shell once it lands.
</script>

<template>
  <Box is="main" class="auth-shell" direction="col">
    <Box class="auth-shell__body">
      <RouterView />
    </Box>
    <AuthFooter />
  </Box>
</template>

<style scoped>
.auth-shell {
  min-height: 100dvh;
  background:
    radial-gradient(circle at 0% 0%, rgba(103, 85, 251, 0.06), transparent 35%),
    radial-gradient(circle at 100% 100%, rgba(103, 85, 251, 0.04), transparent 45%),
    var(--p-surface-50);
}

.auth-shell__body {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.5rem;
  overflow: hidden;
}

@media (max-width: 992px) {
  .auth-shell__body {
    padding: 1.5rem 1rem;
  }
}
</style>
